(function pdfViewerDirectiveDefinition() {
    angular.module('PDFViewer')
           .config(['configProvider', 'languageProvider', function (config, languageProvider) {

               
               PDFJS.imageResourcesPath = config.resourceUrl('components/document-viewer/pdf-viewer/pdfjs/web/images/');
               PDFJS.workerSrc = config.resourceUrl('components/document-viewer/pdf-viewer/pdfjs/build/pdf.worker.js');
               PDFJS.cMapUrl = config.resourceUrl('components/document-viewer/pdf-viewer/pdfjs/web/cmaps/');

               // creo un link <link type="application/l10n" href="..." /> para setear el locale
               var localeRes = null;

               languageProvider.onLanguageChanged([
                   'lang', function languageChanged(language) {

                       var url = config.resourceUrl('components/document-viewer/pdf-viewer/pdfjs/web/locale/' + language + '/viewer.properties');
                       if (!localeRes) {
                           localeRes = angular.element('<link id="pdfLocaleResourceLink" type="application/l10n" href="' + url + '" />');                           
                           $('head').append(localeRes);
                       } else {
                           localeRes.attr('href', url);
                       }
                       
                       var mozL10n = document.mozL10n || document.webL10n;
                       mozL10n.setLanguage(language);
                   }
               ]);
           }])
           .directive('pdfViewer', ['config', 'language', function (config, language) {
               /*
                * USO:
                *
                * <pdf-viewer src="modelo">
                * </pdf-viewer>
                *
                * Donde modelo puede ser un string base 64 o un File.
                */
               var BASE64_MARKER = ';base64,';
               var mozL10n = document.mozL10n || document.webL10n;

               function convertDataURIToBinary(dataURI) {
                   var base64Index = dataURI.indexOf(BASE64_MARKER) + BASE64_MARKER.length;
                   var base64 = dataURI.substring(base64Index);
                   var raw = window.atob(base64);
                   var rawLength = raw.length;
                   var array = new Uint8Array(new ArrayBuffer(rawLength));

                   for (var i = 0; i < rawLength; i++) {
                       array[i] = raw.charCodeAt(i);
                   }
                   return array;
               }

               return {
                   templateUrl: config.resourceUrl('components/document-viewer/pdf-viewer/pdf-viewer.html'),
                   restrict: 'E',
                   scope: {
                       src: '&',
                       enablePresentation: '=',
                       canOpen: '=',
                       canPrint: '=',
                       canDownload: '=',
                       canBookmark: '='
                   },
                   link: function ($scope, $element, $attrs) {

                       var MIN_SCALE = 0.25;
                       var MAX_SCALE = 10.0;

                       var appConfig = getViewerConfiguration();
                       // We reset the eentbus to avoid multiple calls to the bidning.
                       if (PDFViewerApplication.eventBus) {
                           PDFViewerApplication.eventBus._listeners = Object.create(null);
                       }
                       PDFViewerApplication.initialize(appConfig)
                                           .then(webViewerInitialized);

					   // Mark that the pdfViewer is embedded
                       PDFViewerApplication.isViewerEmbedded = true;

                       //Put the correct paths
                       PDFJS.imageResourcesPath = config.resourceUrl('components/document-viewer/pdf-viewer/pdfjs/web/images/');
                       PDFJS.workerSrc = config.resourceUrl('components/document-viewer/pdf-viewer/pdfjs/build/pdf.worker.js');
                       PDFJS.cMapUrl = config.resourceUrl('components/document-viewer/pdf-viewer/pdfjs/web/cmaps/');
                       


                       mozL10n.translate($element[0]);

                       function getViewerElement(id) {
						   return $element.find('#' + id)[0];
                       }

                       function webViewerInitialized() {

                           var fileInput = document.createElement('input');

                           fileInput.id = 'fileInput';
                           fileInput.className = 'fileInput';
                           fileInput.setAttribute('type', 'file');
                           fileInput.style.visibility = 'hidden';
                           fileInput.style.position = 'absolute';
                           fileInput.style.top = '0';
                           //fileInput.oncontextmenu = noContextMenuHandler;

                           document.body.appendChild(fileInput);

                           if (!window.File || !window.FileReader || !window.FileList || !window.Blob) {
                               getViewerElement('openFile').setAttribute('hidden', 'true');
                               getViewerElement('secondaryOpenFile')
                                       .setAttribute('hidden', 'true');
                           } else {
                               document.getElementById('fileInput').value = null;
                           }

                           var locale = PDFJS.locale || navigator.language;

                           if (!PDFViewerApplication.supportsPrinting) {
                               getViewerElement('print').classList.add('hidden');
                               getViewerElement('secondaryPrint').classList.add('hidden');
                           }

                           if (!PDFViewerApplication.supportsFullscreen) {
                               getViewerElement('presentationMode').classList.add('hidden');
                               getViewerElement('secondaryPresentationMode').
                                 classList.add('hidden');
                           }

                           if (PDFViewerApplication.supportsIntegratedFind) {
                               getViewerElement('viewFind').classList.add('hidden');
                           }

                           // Listen for unsupported features to trigger the fallback UI.
                           PDFJS.UnsupportedManager.listen(
                             PDFViewerApplication.fallback.bind(PDFViewerApplication));

                           // Suppress context menus for some controls
                           //getViewerElement('scaleSelect').oncontextmenu = noContextMenuHandler;

                           var mainContainer = getViewerElement('mainContainer');
                           var outerContainer = getViewerElement('outerContainer');
                           mainContainer.addEventListener('transitionend', function (e) {
                               if (e.target === mainContainer) {
                                   var event = document.createEvent('UIEvents');
                                   event.initUIEvent('resize', false, false, window, 0);
                                   window.dispatchEvent(event);
                                   outerContainer.classList.remove('sidebarMoving');
                               }
                           }, true);

                           getViewerElement('sidebarToggle').addEventListener('click',
                             function () {
                                 this.classList.toggle('toggled');
                                 outerContainer.classList.add('sidebarMoving');
                                 outerContainer.classList.toggle('sidebarOpen');
                                 PDFViewerApplication.sidebarOpen = outerContainer.classList.contains('sidebarOpen');
                                 PDFViewerApplication.forceRendering();
                             });

                           getViewerElement('viewOutline').addEventListener('click',
                             function () {
                                 PDFViewerApplication.switchSidebarView('outline');
                             });

                           getViewerElement('viewOutline').addEventListener('dblclick',
                             function () {
                                 PDFViewerApplication.outline.toggleOutlineTree();
                             });

                           getViewerElement('viewAttachments').addEventListener('click',
                             function () {
                                 PDFViewerApplication.switchSidebarView('attachments');
                             });

                           getViewerElement('previous').addEventListener('click',
                             function () {
                                 PDFViewerApplication.page--;
                             });

                           getViewerElement('next').addEventListener('click',
                             function () {
                                 PDFViewerApplication.page++;
                             });

                           getViewerElement('zoomIn').addEventListener('click',
                             function () {
                                 PDFViewerApplication.zoomIn();
                             });

                           getViewerElement('zoomOut').addEventListener('click',
                             function () {
                                 PDFViewerApplication.zoomOut();
                             });

                           getViewerElement('pageNumber').addEventListener('click', function () {
                               this.select();
                           });

                           getViewerElement('pageNumber').addEventListener('change', function () {
                               // Handle the user inputting a floating point number.
                               PDFViewerApplication.page = (this.value | 0);

                               if (this.value !== (this.value | 0).toString()) {
                                   this.value = PDFViewerApplication.page;
                               }
                           });

                           getViewerElement('scaleSelect').addEventListener('change', function () {
                               if (this.value === 'custom') {
                                   return;
                               }
                               PDFViewerApplication.pdfViewer.currentScaleValue = this.value;
                           });


                           //SecondaryToolbar = secondaryToolbar;
                           //getViewerElement('presentationMode').addEventListener('click', SecondaryToolbar.presentationModeClick.bind(SecondaryToolbar));

                           //getViewerElement('openFile').addEventListener('click', SecondaryToolbar.openFileClick.bind(SecondaryToolbar));

                           //getViewerElement('print').addEventListener('click', SecondaryToolbar.printClick.bind(SecondaryToolbar));

                           //getViewerElement('download').addEventListener('click', SecondaryToolbar.downloadClick.bind(SecondaryToolbar));

                           $scope.$watch(function () {
                               return $scope.src();
                           }, function (src) {

                               PDFViewerApplication.close();

                               if (src) {

                                   if (typeof (src) === 'string') {
                                       if (src.indexOf('data:') === 0) {
                                           // como el PDF viewer usa un XMLHttpRequest y estos no soportan urls de tipo data:
                                           // entonces lo convierto a un array de bytes que eso si lo soporta.
                                           src = convertDataURIToBinary(src);

                                       } else if (src.indexOf('file:') === 0) {
                                           // file:-scheme. Load the contents in the main thread because QtWebKit
                                           // cannot load file:-URLs in a Web Worker. file:-URLs are usually loaded
                                           // very quickly, so there is no need to set up progress event listeners.
                                           PDFViewerApplication.setTitleUsingUrl(src);

                                           var xhr = new XMLHttpRequest();
                                           xhr.onload = function () {
                                               var newSrc = new Uint8Array(xhr.response);
                                               PDFViewerApplication.src = newSrc;
                                               PDFViewerApplication.open(newSrc, 0);
                                           };
                                           try {
                                               xhr.open('GET', src);
                                               xhr.responseType = 'arraybuffer';
                                               xhr.send();
                                           } catch (e) {
                                               PDFViewerApplication.error(mozL10n.get('loading_error', null,
                                                 'An error occurred while loading the PDF.'), e);
                                           }
                                           return;
                                       }
                                       PDFViewerApplication.src = src;
                                       PDFViewerApplication.open(src);
                                   } else {
                                       var fileReader = new FileReader();

                                       fileReader.onload = function () {
                                           // Invoke the callback.
                                           var newSrc = new Uint8Array(this.result);
                                           PDFViewerApplication.src = newSrc;
                                           PDFViewerApplication.open(newSrc);
                                       };
                                       fileReader.readAsArrayBuffer(src);
                                   }
                               }

                           });
                       }

                       function pagerendered(e) {
                           var pageNumber = e.detail.pageNumber;
                           var pageIndex = pageNumber - 1;
                           var pageView = PDFViewerApplication.pdfViewer.getPageView(pageIndex);

                           if (PDFViewerApplication.sidebarOpen) {
                               var thumbnailView = PDFViewerApplication.pdfThumbnailViewer.getThumbnail(pageIndex);
                               thumbnailView.setImage(pageView);
                           }

                           if (pageView.error) {
                               PDFViewerApplication.error(mozL10n.get('rendering_error', null,
                                 'An error occurred while rendering the page.'), pageView.error);
                           }

                           // If the page is still visible when it has finished rendering,
                           // ensure that the page number input loading indicator is hidden.
                           //if (pageNumber === PDFViewerApplication.page) {
                           //    var pageNumberInput = document.getElementById('pageNumber');
                           //    pageNumberInput.classList.remove(PAGE_NUMBER_LOADING_INDICATOR);
                           //}

                       }

                       function textlayerrendered(e) {
                           var pageIndex = e.detail.pageNumber - 1;
                           var pageView = PDFViewerApplication.pdfViewer.getPageView(pageIndex);

                       }

                       function pagemode(evt) {
                           if (!PDFViewerApplication.initialized) {
                               return;
                           }
                           // Handle the 'pagemode' hash parameter, see also `PDFLinkService_setHash`.
                           var mode = evt.detail.mode;
                           switch (mode) {
                               case 'bookmarks':
                                   // Note: Our code calls this property 'outline', even though the
                                   //       Open Parameter specification calls it 'bookmarks'.
                                   mode = 'outline';
                                   /* falls through */
                               case 'thumbs':
                               case 'attachments':
                                   PDFViewerApplication.switchSidebarView(mode, true);
                                   break;
                               case 'none':
                                   if (PDFViewerApplication.sidebarOpen) {
                                       document.getElementById('sidebarToggle').click();
                                   }
                                   break;
                           }
                       }

                       function namedaction(e) {
                           if (!PDFViewerApplication.initialized) {
                               return;
                           }
                           // Processing couple of named actions that might be useful.
                           // See also PDFLinkService.executeNamedAction
                           var action = e.detail.action;
                           switch (action) {
                               case 'GoToPage':
                                   document.getElementById('pageNumber').focus();
                                   break;

                               case 'Find':
                                   if (!PDFViewerApplication.supportsIntegratedFind) {
                                       PDFViewerApplication.findBar.toggle();
                                   }
                                   break;
                           }
                       }

                       function presentationmodechanged(e) {
                           var active = e.detail.active;
                           var switchInProgress = e.detail.switchInProgress;
                           PDFViewerApplication.pdfViewer.presentationModeState =
                             switchInProgress ? PresentationModeState.CHANGING :
                             active ? PresentationModeState.FULLSCREEN : PresentationModeState.NORMAL;
                       }

                       function updateviewarea(evt) {
                           if (!PDFViewerApplication.initialized) {
                               return;
                           }
                           var location = evt.location;

                           PDFViewerApplication.store.initializedPromise.then(function () {
                               PDFViewerApplication.store.setMultiple({
                                   'exists': true,
                                   'page': location.pageNumber,
                                   'zoom': location.scale,
                                   'scrollLeft': location.left,
                                   'scrollTop': location.top
                               }).catch(function () {
                                   // unable to write to storage
                               });
                           });

                           // Show/hide the loading indicator in the page number input element.
                           var pageNumberInput = document.getElementById('pageNumber');
                           var currentPage = PDFViewerApplication.pdfViewer.getPageView(PDFViewerApplication.page - 1);

                           //if (currentPage.renderingState === RenderingStates.FINISHED) {
                           //    pageNumberInput.classList.remove(PAGE_NUMBER_LOADING_INDICATOR);
                           //} else {
                           //    pageNumberInput.classList.add(PAGE_NUMBER_LOADING_INDICATOR);
                           //}
                       }

                       function webViewerResize(evt) {
                           if (PDFViewerApplication.initialized) {
                               var currentScaleValue = PDFViewerApplication.pdfViewer.currentScaleValue;
                               if (currentScaleValue === 'auto' ||
                                   currentScaleValue === 'page-fit' ||
                                   currentScaleValue === 'page-width') {
                                   // Note: the scale is constant for 'page-actual'.
                                   PDFViewerApplication.pdfViewer.currentScaleValue = currentScaleValue;
                               } else if (!currentScaleValue) {
                                   // Normally this shouldn't happen, but if the scale wasn't initialized
                                   // we set it to the default value in order to prevent any issues.
                                   // (E.g. the document being rendered with the wrong scale on load.)
                                   PDFViewerApplication.pdfViewer.currentScaleValue = 'auto';
                               }
                               PDFViewerApplication.pdfViewer.update();
                           }

                           // Set the 'max-height' CSS property of the secondary toolbar.
                           //SecondaryToolbar.setMaxHeight(document.getElementById('viewerContainer'));
                       }
                       function selectScaleOption(value) {
                           var options = document.getElementById('scaleSelect').options;
                           var predefinedValueFound = false;
                           for (var i = 0, ii = options.length; i < ii; i++) {
                               var option = options[i];
                               if (option.value !== value) {
                                   option.selected = false;
                                   continue;
                               }
                               option.selected = true;
                               predefinedValueFound = true;
                           }
                           return predefinedValueFound;
                       }

                       function localized(evt) {
                           document.getElementsByTagName('html')[0].dir = mozL10n.getDirection();

                           PDFViewerApplication.animationStartedPromise.then(function () {
                               // Adjust the width of the zoom box to fit the content.
                               // Note: If the window is narrow enough that the zoom box is not visible,
                               //       we temporarily show it to be able to adjust its width.
                               var container = document.getElementById('scaleSelectContainer');
                               if (container.clientWidth === 0) {
                                   container.setAttribute('style', 'display: inherit;');
                               }
                               if (container.clientWidth > 0) {
                                   var select = document.getElementById('scaleSelect');
                                   select.setAttribute('style', 'min-width: inherit;');
                                   var width = select.clientWidth + SCALE_SELECT_CONTAINER_PADDING;
                                   select.setAttribute('style', 'min-width: ' +
                                                                (width + SCALE_SELECT_PADDING) + 'px;');
                                   container.setAttribute('style', 'min-width: ' + width + 'px; ' +
                                                                   'max-width: ' + width + 'px;');
                               }

                               // Set the 'max-height' CSS property of the secondary toolbar.
                               //SecondaryToolbar.setMaxHeight(document.getElementById('viewerContainer'));
                           });
                       }

                       function scalechange(evt) {
                           document.getElementById('zoomOut').disabled = (evt.scale === MIN_SCALE);
                           document.getElementById('zoomIn').disabled = (evt.scale === MAX_SCALE);

                           // Update the 'scaleSelect' DOM element.
                           var predefinedValueFound = selectScaleOption(evt.presetValue ||
                                                                        '' + evt.scale);
                           if (!predefinedValueFound) {
                               var customScaleOption = document.getElementById('customScaleOption');
                               var customScale = Math.round(evt.scale * 10000) / 100;
                               customScaleOption.textContent =
                                 mozL10n.get('page_scale_percent', { scale: customScale }, '{{scale}}%');
                               customScaleOption.selected = true;
                           }
                           if (!PDFViewerApplication.initialized) {
                               return;
                           }
                           PDFViewerApplication.pdfViewer.update();
                       }

                       function pagechange(evt) {
                           var page = evt.pageNumber;
                           if (evt.previousPageNumber !== page) {
                               document.getElementById('pageNumber').value = page;
                               if (PDFViewerApplication.sidebarOpen) {
                                   PDFViewerApplication.pdfThumbnailViewer.scrollThumbnailIntoView(page);
                               }
                           }
                           var numPages = PDFViewerApplication.pagesCount;

                           document.getElementById('previous').disabled = (page <= 1);
                           document.getElementById('next').disabled = (page >= numPages);

                           document.getElementById('firstPage').disabled = (page <= 1);
                           document.getElementById('lastPage').disabled = (page >= numPages);
                       }

                       function handleMouseWheel(evt) {
                           var MOUSE_WHEEL_DELTA_FACTOR = 40;
                           var ticks = (evt.type === 'DOMMouseScroll') ? -evt.detail :
                                       evt.wheelDelta / MOUSE_WHEEL_DELTA_FACTOR;
                           var direction = (ticks < 0) ? 'zoomOut' : 'zoomIn';

                           var pdfViewer = PDFViewerApplication.pdfViewer;
                           if (pdfViewer.isInPresentationMode) {
                               evt.preventDefault();
                               PDFViewerApplication.scrollPresentationMode(ticks *
                                                                           MOUSE_WHEEL_DELTA_FACTOR);
                           } else if (evt.ctrlKey || evt.metaKey) {
                               var support = PDFViewerApplication.supportedMouseWheelZoomModifierKeys;
                               if ((evt.ctrlKey && !support.ctrlKey) ||
                                   (evt.metaKey && !support.metaKey)) {
                                   return;
                               }
                               // Only zoom the pages, not the entire viewer.
                               evt.preventDefault();

                               var previousScale = pdfViewer.currentScale;

                               PDFViewerApplication[direction](Math.abs(ticks));

                               var currentScale = pdfViewer.currentScale;
                               if (previousScale !== currentScale) {
                                   // After scaling the page via zoomIn/zoomOut, the position of the upper-
                                   // left corner is restored. When the mouse wheel is used, the position
                                   // under the cursor should be restored instead.
                                   var scaleCorrectionFactor = currentScale / previousScale - 1;
                                   var rect = pdfViewer.container.getBoundingClientRect();
                                   var dx = evt.clientX - rect.left;
                                   var dy = evt.clientY - rect.top;
                                   pdfViewer.container.scrollLeft += dx * scaleCorrectionFactor;
                                   pdfViewer.container.scrollTop += dy * scaleCorrectionFactor;
                               }
                           }
                       }

                       function click(evt) {
                           //if (SecondaryToolbar.opened &&
                           //    PDFViewerApplication.pdfViewer.containsElement(evt.target)) {
                           //    SecondaryToolbar.close();
                           //}
                       }

                       function keydown(evt) {
                           //if (OverlayManager.active) {
                           //    return;
                           //}

                           var handled = false;
                           var cmd = (evt.ctrlKey ? 1 : 0) |
                                     (evt.altKey ? 2 : 0) |
                                     (evt.shiftKey ? 4 : 0) |
                                     (evt.metaKey ? 8 : 0);

                           var pdfViewer = PDFViewerApplication.pdfViewer;
                           var isViewerInPresentationMode = pdfViewer && pdfViewer.isInPresentationMode;

                           // First, handle the key bindings that are independent whether an input
                           // control is selected or not.
                           if (cmd === 1 || cmd === 8 || cmd === 5 || cmd === 12) {
                               // either CTRL or META key with optional SHIFT.
                               switch (evt.keyCode) {
                                   case 70: // f
                                       if (!PDFViewerApplication.supportsIntegratedFind) {
                                           PDFViewerApplication.findBar.open();
                                           handled = true;
                                       }
                                       break;
                                   case 71: // g
                                       if (!PDFViewerApplication.supportsIntegratedFind) {
                                           PDFViewerApplication.findBar.dispatchEvent('again',
                                                                                      cmd === 5 || cmd === 12);
                                           handled = true;
                                       }
                                       break;
                                   case 61: // FF/Mac '='
                                   case 107: // FF '+' and '='
                                   case 187: // Chrome '+'
                                   case 171: // FF with German keyboard
                                       if (!isViewerInPresentationMode) {
                                           PDFViewerApplication.zoomIn();
                                       }
                                       handled = true;
                                       break;
                                   case 173: // FF/Mac '-'
                                   case 109: // FF '-'
                                   case 189: // Chrome '-'
                                       if (!isViewerInPresentationMode) {
                                           PDFViewerApplication.zoomOut();
                                       }
                                       handled = true;
                                       break;
                                   case 48: // '0'
                                   case 96: // '0' on Numpad of Swedish keyboard
                                       if (!isViewerInPresentationMode) {
                                           // keeping it unhandled (to restore page zoom to 100%)
                                           setTimeout(function () {
                                               // ... and resetting the scale after browser adjusts its scale
                                               pdfViewer.currentScaleValue = 'auto';
                                           });
                                           handled = false;
                                       }
                                       break;
                               }
                           }

                           // CTRL or META without shift
                           if (cmd === 1 || cmd === 8) {
                               switch (evt.keyCode) {
                                   case 83: // s
                                       //PDFViewerApplication.download();
                                       handled = true;
                                       break;
                               }
                           }

                           // CTRL+ALT or Option+Command
                           if (cmd === 3 || cmd === 10) {
                               switch (evt.keyCode) {
                                   case 80: // p
                                       PDFViewerApplication.requestPresentationMode();
                                       handled = true;
                                       break;
                                   case 71: // g
                                       // focuses input#pageNumber field
                                       document.getElementById('pageNumber').select();
                                       handled = true;
                                       break;
                               }
                           }

                           if (handled) {
                               evt.preventDefault();
                               return;
                           }

                           // Some shortcuts should not get handled if a control/input element
                           // is selected.
                           var curElement = document.activeElement || document.querySelector(':focus');
                           var curElementTagName = curElement && curElement.tagName.toUpperCase();
                           if (curElementTagName === 'INPUT' ||
                               curElementTagName === 'TEXTAREA' ||
                               curElementTagName === 'SELECT') {
                               // Make sure that the secondary toolbar is closed when Escape is pressed.
                               if (evt.keyCode !== 27) { // 'Esc'
                                   return;
                               }
                           }
                           var ensureViewerFocused = false;

                           if (cmd === 0) { // no control key pressed at all.
                               switch (evt.keyCode) {
                                   case 38: // up arrow
                                   case 33: // pg up
                                   case 8: // backspace
                                       if (!isViewerInPresentationMode &&
                                           pdfViewer.currentScaleValue !== 'page-fit') {
                                           break;
                                       }
                                       /* in presentation mode */
                                       /* falls through */
                                   case 37: // left arrow
                                       // horizontal scrolling using arrow keys
                                       if (pdfViewer.isHorizontalScrollbarEnabled) {
                                           break;
                                       }
                                       /* falls through */
                                   case 75: // 'k'
                                   case 80: // 'p'
                                       PDFViewerApplication.page--;
                                       handled = true;
                                       break;
                                   case 27: // esc key
                                       //if (SecondaryToolbar.opened) {
                                       //    SecondaryToolbar.close();
                                       //    handled = true;
                                       //}
                                       if (!PDFViewerApplication.supportsIntegratedFind &&
                                           PDFViewerApplication.findBar.opened) {
                                           PDFViewerApplication.findBar.close();
                                           handled = true;
                                       }
                                       break;
                                   case 40: // down arrow
                                   case 34: // pg down
                                   case 32: // spacebar
                                       if (!isViewerInPresentationMode &&
                                           pdfViewer.currentScaleValue !== 'page-fit') {
                                           break;
                                       }
                                       /* falls through */
                                   case 39: // right arrow
                                       // horizontal scrolling using arrow keys
                                       if (pdfViewer.isHorizontalScrollbarEnabled) {
                                           break;
                                       }
                                       /* falls through */
                                   case 74: // 'j'
                                   case 78: // 'n'
                                       PDFViewerApplication.page++;
                                       handled = true;
                                       break;

                                   case 36: // home
                                       if (isViewerInPresentationMode || PDFViewerApplication.page > 1) {
                                           PDFViewerApplication.page = 1;
                                           handled = true;
                                           ensureViewerFocused = true;
                                       }
                                       break;
                                   case 35: // end
                                       if (isViewerInPresentationMode || (PDFViewerApplication.pdfDocument &&
                                           PDFViewerApplication.page < PDFViewerApplication.pagesCount)) {
                                           PDFViewerApplication.page = PDFViewerApplication.pagesCount;
                                           handled = true;
                                           ensureViewerFocused = true;
                                       }
                                       break;

                                   case 72: // 'h'
                                       if (!isViewerInPresentationMode) {
                                           HandTool.toggle();
                                       }
                                       break;
                                   case 82: // 'r'
                                       PDFViewerApplication.rotatePages(90);
                                       break;
                               }
                           }

                           if (cmd === 4) { // shift-key
                               switch (evt.keyCode) {
                                   case 32: // spacebar
                                       if (!isViewerInPresentationMode &&
                                           pdfViewer.currentScaleValue !== 'page-fit') {
                                           break;
                                       }
                                       PDFViewerApplication.page--;
                                       handled = true;
                                       break;

                                   case 82: // 'r'
                                       PDFViewerApplication.rotatePages(-90);
                                       break;
                               }
                           }

                           if (!handled && !isViewerInPresentationMode) {
                               // 33=Page Up  34=Page Down  35=End    36=Home
                               // 37=Left     38=Up         39=Right  40=Down
                               // 32=Spacebar
                               if ((evt.keyCode >= 33 && evt.keyCode <= 40) ||
                                   (evt.keyCode === 32 && curElementTagName !== 'BUTTON')) {
                                   ensureViewerFocused = true;
                               }
                           }

                           if (cmd === 2) { // alt-key
                               switch (evt.keyCode) {
                                   case 37: // left arrow
                                       if (isViewerInPresentationMode) {
                                           PDFViewerApplication.pdfHistory.back();
                                           handled = true;
                                       }
                                       break;
                                   case 39: // right arrow
                                       if (isViewerInPresentationMode) {
                                           PDFViewerApplication.pdfHistory.forward();
                                           handled = true;
                                       }
                                       break;
                               }
                           }

                           if (ensureViewerFocused && !pdfViewer.containsElement(curElement)) {
                               // The page container is not focused, but a page navigation key has been
                               // pressed. Change the focus to the viewer container to make sure that
                               // navigation by keyboard works as expected.
                               pdfViewer.focus();
                           }

                           if (handled) {
                               evt.preventDefault();
                           }
                       }
                       
                       var oldParent = null,
                           oldSibling = null;

                       window.print = function print() {
                           var blob = new Blob([PDFViewerApplication.src], { type: 'application/pdf;base64' });
                           var url = URL.createObjectURL(blob);

                           var viewerUrl = config.resourceUrl('components/document-viewer/pdf-viewer/pdfjs/web/viewer.html?file=' + encodeURIComponent(url));
                           window.open(viewerUrl);
                           return false;
                       };

                       function beforePrint(evt) {
                           var body = $('body');

                           oldSibling = $element.prev();
                           oldParent = $element.parent();

                           $element.detach();

                           var children = body.children();

                           for (var i = 0; i < children.length; i++) {
                               children[i].oldDisplay = children[i].style.display;
                               children[i].style.display = 'none';
                           }

                           $element.appendTo(body);

                           //if (!PDFViewerApplication.overlayManager.overlays["printServiceOverlay"])
                           //    PDFViewerApplication.overlayManager.register('printServiceOverlay', document.getElementById('printServiceOverlay'), abort, true);

                           PDFViewerApplication.beforePrint();
                       }
                       function afterPrint(evt) {

                           var body = $('body');

                           $element.detach();

                           var children = body.children();

                           for (var i = 0; i < children.length; i++) {
                               children[i].style.display = children[i].oldDisplay;
                           }

                           if (oldSibling.length) {
                               $element.insertAfter(oldSibling);
                           } else {
                               $element.appendTo(oldParent);
                           }

                           //We mark the overlay as inactive becaise we already change the overlay
                           PDFViewerApplication.overlayManager.active = null;

                           PDFViewerApplication.afterPrint();
                       }

                       window.addEventListener('DOMMouseScroll', handleMouseWheel);
                       window.addEventListener('mousewheel', handleMouseWheel);
                       window.addEventListener('click', click, false);
                       window.addEventListener('keydown', keydown);
                       window.addEventListener('beforeprint', beforePrint);
                       window.addEventListener('afterprint', afterPrint);
                       window.addEventListener('pagechange', pagechange, true);
                       window.addEventListener('scalechange', scalechange, true);
                       window.addEventListener('localized', localized, true);
                       window.addEventListener('resize', webViewerResize);
                       window.addEventListener('updateviewarea', updateviewarea, true);
                       window.addEventListener('presentationmodechanged', presentationmodechanged);

                       document.addEventListener('pagerendered', pagerendered, true);
                       document.addEventListener('namedaction', namedaction, true);
                       document.addEventListener('pagemode', pagemode, true);
                       document.addEventListener('textlayerrendered', textlayerrendered, true);

                       $scope.$on('$destroy', function () {
                           // remuevo la registración de los eventos.
                           window.removeEventListener('afterprint', afterPrint);
                           window.removeEventListener('beforeprint', beforePrint);
                           window.removeEventListener('keydown', keydown);
                           window.removeEventListener('DOMMouseScroll', handleMouseWheel);
                           window.removeEventListener('mousewheel', handleMouseWheel);
                           window.removeEventListener('click', click, false);
                           window.removeEventListener('pagechange', pagechange, true);
                           window.removeEventListener('scalechange', scalechange, true);
                           window.removeEventListener('localized', localized, true);
                           window.removeEventListener('resize', webViewerResize);
                           window.removeEventListener('updateviewarea', updateviewarea, true);
                           window.removeEventListener('presentationmodechanged', presentationmodechanged);

                           document.removeEventListener('pagerendered', pagerendered, true);
                           document.removeEventListener('namedaction', namedaction, true);
                           document.removeEventListener('pagemode', pagemode, true);
                           document.removeEventListener('textlayerrendered', textlayerrendered, true);

                           if(PDFViewerApplication.overlayManager.overlays["documentPropertiesOverlay"])
                               PDFViewerApplication.overlayManager.unregister("documentPropertiesOverlay");
                           if (PDFViewerApplication.overlayManager.overlays["passwordOverlay"])
                               PDFViewerApplication.overlayManager.unregister("passwordOverlay");
                           if (PDFViewerApplication.overlayManager.overlays["printServiceOverlay"])
                               PDFViewerApplication.overlayManager.unregister("printServiceOverlay");
						   
						   //We add tos to avoid that the eventBus have a lot of listeners and open the document for print more than once (CSPROD-3319)
						   PDFViewerApplication.eventBus._listeners.print.splice(0, 1);
						   
                           PDFViewerApplication.close();
                       });

                       function getViewerConfiguration() {
                           return {
                               appContainer: document.body,
                               mainContainer: document.getElementById('viewerContainer'),
                               viewerContainer: document.getElementById('viewer'),
                               eventBus: null,
                               toolbar: {
                                   container: document.getElementById('toolbarViewer'),
                                   numPages: document.getElementById('numPages'),
                                   pageNumber: document.getElementById('pageNumber'),
                                   scaleSelectContainer: document.getElementById('scaleSelectContainer'),
                                   scaleSelect: document.getElementById('scaleSelect'),
                                   customScaleOption: document.getElementById('customScaleOption'),
                                   previous: document.getElementById('previous'),
                                   next: document.getElementById('next'),
                                   zoomIn: document.getElementById('zoomIn'),
                                   zoomOut: document.getElementById('zoomOut'),
                                   viewFind: document.getElementById('viewFind'),
                                   openFile: document.getElementById('openFile'),
                                   print: document.getElementById('print'),
                                   presentationModeButton: document.getElementById('presentationMode'),
                                   download: document.getElementById('download'),
                                   viewBookmark: document.getElementById('viewBookmark')
                               },
                               secondaryToolbar: {
                                   toolbar: document.getElementById('secondaryToolbar'),
                                   toggleButton: document.getElementById('secondaryToolbarToggle'),
                                   toolbarButtonContainer: document.getElementById('secondaryToolbarButtonContainer'),
                                   presentationModeButton: document.getElementById('secondaryPresentationMode'),
                                   openFileButton: document.getElementById('secondaryOpenFile'),
                                   printButton: document.getElementById('secondaryPrint'),
                                   downloadButton: document.getElementById('secondaryDownload'),
                                   viewBookmarkButton: document.getElementById('secondaryViewBookmark'),
                                   firstPageButton: document.getElementById('firstPage'),
                                   lastPageButton: document.getElementById('lastPage'),
                                   pageRotateCwButton: document.getElementById('pageRotateCw'),
                                   pageRotateCcwButton: document.getElementById('pageRotateCcw'),
                                   toggleHandToolButton: document.getElementById('toggleHandTool'),
                                   documentPropertiesButton: document.getElementById('documentProperties')
                               },
                               fullscreen: {
                                   contextFirstPage: document.getElementById('contextFirstPage'),
                                   contextLastPage: document.getElementById('contextLastPage'),
                                   contextPageRotateCw: document.getElementById('contextPageRotateCw'),
                                   contextPageRotateCcw: document.getElementById('contextPageRotateCcw')
                               },
                               sidebar: {
                                   mainContainer: document.getElementById('mainContainer'),
                                   outerContainer: document.getElementById('outerContainer'),
                                   toggleButton: document.getElementById('sidebarToggle'),
                                   thumbnailButton: document.getElementById('viewThumbnail'),
                                   outlineButton: document.getElementById('viewOutline'),
                                   attachmentsButton: document.getElementById('viewAttachments'),
                                   thumbnailView: document.getElementById('thumbnailView'),
                                   outlineView: document.getElementById('outlineView'),
                                   attachmentsView: document.getElementById('attachmentsView')
                               },
                               findBar: {
                                   bar: document.getElementById('findbar'),
                                   toggleButton: document.getElementById('viewFind'),
                                   findField: document.getElementById('findInput'),
                                   highlightAllCheckbox: document.getElementById('findHighlightAll'),
                                   caseSensitiveCheckbox: document.getElementById('findMatchCase'),
                                   findMsg: document.getElementById('findMsg'),
                                   findResultsCount: document.getElementById('findResultsCount'),
                                   findStatusIcon: document.getElementById('findStatusIcon'),
                                   findPreviousButton: document.getElementById('findPrevious'),
                                   findNextButton: document.getElementById('findNext')
                               },
                               passwordOverlay: {
                                   overlayName: 'passwordOverlay',
                                   container: document.getElementById('passwordOverlay'),
                                   label: document.getElementById('passwordText'),
                                   input: document.getElementById('password'),
                                   submitButton: document.getElementById('passwordSubmit'),
                                   cancelButton: document.getElementById('passwordCancel')
                               },
                               documentProperties: {
                                   overlayName: 'documentPropertiesOverlay',
                                   container: document.getElementById('documentPropertiesOverlay'),
                                   closeButton: document.getElementById('documentPropertiesClose'),
                                   fields: {
                                       'fileName': document.getElementById('fileNameField'),
                                       'fileSize': document.getElementById('fileSizeField'),
                                       'title': document.getElementById('titleField'),
                                       'author': document.getElementById('authorField'),
                                       'subject': document.getElementById('subjectField'),
                                       'keywords': document.getElementById('keywordsField'),
                                       'creationDate': document.getElementById('creationDateField'),
                                       'modificationDate': document.getElementById('modificationDateField'),
                                       'creator': document.getElementById('creatorField'),
                                       'producer': document.getElementById('producerField'),
                                       'version': document.getElementById('versionField'),
                                       'pageCount': document.getElementById('pageCountField')
                                   }
                               },
                               errorWrapper: {
                                   container: document.getElementById('errorWrapper'),
                                   errorMessage: document.getElementById('errorMessage'),
                                   closeButton: document.getElementById('errorClose'),
                                   errorMoreInfo: document.getElementById('errorMoreInfo'),
                                   moreInfoButton: document.getElementById('errorShowMore'),
                                   lessInfoButton: document.getElementById('errorShowLess')
                               },
                               printContainer: document.getElementById('printContainer'),
                               openFileInputName: 'fileInput',
                               debuggerScriptPath: './debugger.js',
                               defaultUrl: 'compressed.tracemonkey-pldi-09.pdf'
                           };
                       }


                   }
               };
           }]);
})();
